import React from 'react';
import styles from './ProgressBar.module.css';

export default function ProgressBar({ now = 0, max = 100, label, variant = 'primary', className = '', ...rest }) {
  const percentage = Math.min(100, Math.max(0, (now / max) * 100));
  return (
    <div className={`${styles.progress} ${className}`} {...rest}>
      <div
        className={`${styles.bar} ${styles[variant] || styles.primary}`}
        style={{ width: `${percentage}%` }}
      >
        {label && <span className={styles.label}>{label}</span>}
      </div>
    </div>
  );
}
